import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import LanguageSelect from 'components/LanguageSelect';
import PrimaryAddButton from 'components/PrimaryAddButton';
import SearchInput from 'components/SearchInput';
import { useSession } from 'components/Authenticated';
import MergeButton from './MergeButton';
import { defaultSieve } from '../SpeakersTable';
import styles from './style.module.less';
const SpeakersToolbar = ({ tableView, onAdd, localization, onRefetch, selectedSpeakerRows, onDeselect, }) => {
    // NOTE: Forces SearchInput to remount on filter clear
    // — Form initialValues are read-only after mount
    const [resetSearchKey, setResetSearchKey] = useState(Date.now());
    const { session, updateUserSettings } = useSession();
    const { login: { user: { settings: { speakerSettings } } } } = session;
    const { sieve } = tableView.getViewParams();
    const { sortBy, sortOrder, filters, updatedDates, search, } = sieve !== null && sieve !== void 0 ? sieve : defaultSieve;
    const handleSearch = useCallback((query) => {
        if (query !== '') {
            tableView.setCurrentPage(1);
        }
        tableView.setSieve(Object.assign(Object.assign({}, sieve), { filterDates: [], search: query === '' ? undefined : query }));
    }, [sieve, tableView]);
    const isSortingOrFiltering = !(sortBy === 'lastUpdated'
        && sortOrder === 'descend'
        && (filters === undefined || filters.speakerIdActive === null)
        && (updatedDates === undefined || updatedDates.length === 0)
        && (search === undefined || search === ''));
    const handleClearAll = () => {
        tableView.setCurrentPage(1);
        tableView.setSieve(Object.assign(Object.assign({}, defaultSieve), { langs: sieve === null || sieve === void 0 ? void 0 : sieve.langs }));
        setResetSearchKey(Date.now());
    };
    const handleLanguageChange = (langs) => {
        var _a;
        const langCodes = langs.map((l) => l.code);
        tableView.setSieve(Object.assign(Object.assign({}, sieve), { filterDates: (_a = sieve === null || sieve === void 0 ? void 0 : sieve.filterDates) !== null && _a !== void 0 ? _a : [], langs: langCodes }));
        updateUserSettings({
            speakerSettings: Object.assign(Object.assign({}, speakerSettings), { languageFilter: langCodes }),
        });
    };
    return (_jsxs("div", { className: styles.toolbar, children: [_jsxs("div", { className: styles.toolbarLeft, children: [_jsx(PrimaryAddButton, { label: txt('addSpeaker'), onClick: onAdd }), _jsx(MergeButton, { selectedSpeakerRows: selectedSpeakerRows, onSuccess: async () => {
                            await onRefetch();
                            onDeselect();
                        } }), isSortingOrFiltering ? (_jsxs(Button, { type: "link", onClick: handleClearAll, children: [_jsx(CloseOutlined, {}), _jsx("span", { children: txt('clearAll') })] })) : null] }), _jsxs("div", { className: styles.toolbarRight, children: [_jsx("span", { className: styles.inputLabel, children: `${txt('speakersForLanguages')}:` }), _jsx(LanguageSelect, { multiple: true, className: styles.languageSelect, locales: localization.locales, value: localization.selectedLangs, onChange: handleLanguageChange }), _jsx(SearchInput, { placeholder: txt('findSpeaker'), onSearch: handleSearch, initialValues: { search: sieve === null || sieve === void 0 ? void 0 : sieve.search } }, resetSearchKey)] })] }));
};
export default SpeakersToolbar;
